<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="bazaarvoiceReview-container">
          <div class="row">
            <div class="col-md-3">
              <div class="profile-container">
                <div class="image-container"></div>
                <div class="description-container">
                  <p class="title">Emma F.</p>
                  <p>Votes 19</p>
                  <p>Age 18 to 24</p>
                  <p>Gender: Female</p>
                </div>
              </div>
            </div>
            <div class="col-md-9">
              <div class="product-container">
                <div class="image-container"></div>
                <div class="prodcut-description-container">
                  <p>her favorite product</p>
                  <h3>multi-purpose cica repair balm</h3>
                  <div class="star-rating-container">
                    <StarRating
                      :increment="0.01"
                      :read-only="true"
                      active-color="#337ab7"
                      :border-width="3"
                      border-color="transparent"
                      :rounded-corners="true"
                      rating="4.5"
                      :star-size="30"
                      :star-points="[
                        23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17,
                      ]"
                      :show-rating="false"
                    >
                    </StarRating>
                  </div>
                  <h5>24 months ago</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="reivew-container">
              <div class="col-md-8">
                <div class="inner-container">
                  <h4>title of review</h4>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                    Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                    unknown printer took a galley of type and scrambled it to make a type specimen
                    book. It has survived not only five centuries, but also the leap into electronic
                    typesetting, remaining essentially unchanged. It was popularised in the 1960s
                    with the release of Letraset sheets containing Lorem Ipsum passages, and more
                    recently with desktop publishing software like Aldus PageMaker including
                    versions of Lorem Ipsum.
                  </p>
                </div>
              </div>
              <div class="col-md-12"></div>
            </div>
          </div>
          <div class="row">
            <div class="comment-container">
              <div class="col-md-4">
                <div class="left-comment"><h4>Yes. i recommend this product.</h4></div>
              </div>
              <div class="col-md-8">
                <div class="right-comment">
                  <h4>
                    <span class="helptext">Helpful? </span> Yes | <span class="number">19</span> NO
                    | <span class="number">4</span> report
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="amazon-container">
              <div class="col-md-3">
                <div class="image-container"></div>
              </div>
              <div class="col-md-9">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                  Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                  unknown printer took a galley of type and scrambled it to make a type specimen
                  book. It has survived not only five centuries, but also the leap into electronic
                  typesetting, remaining essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum passages, and more recently
                  with desktop publishing software like Aldus PageMaker including versions of Lorem
                  Ipsum.
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="pagination-container">
                <div>
                  <div class="left-triangle"></div>
                  <div class="text-content">2 OF 78</div>
                  <div class="right-triangle"></div>
                  <div style="clear: both"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bazaarvoice-review',
  props: {
    reviews: {
      type: String,
      required: true,
    },
  },
};
</script>
